<template>
  <main>
    <UtilRendererContent
      v-if="content"
      :data="content"
    />
  </main>
</template>

<script setup>
definePageMeta({
    layout: 'loggedout',
    middleware: [
        'page-permission',
        'auth-guest',
    ],
});

const { content, seo } = getPageContent('login-magic');

useHead({
    title: seo?.title || '',
});
</script>
